function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeliver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 640 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48,32l304,0c26.5,0 48,21.5 48,48l0,160c0,26.5 -21.5,48 -48,48l-304,0c-26.5,0 -48,-21.5 -48,-48l0,-160c0,-26.5 21.5,-48 48,-48Zm32,48c-8.8,0 -16,7.2 -16,16l0,128c0,8.8 7.2,16 16,16c8.8,0 16,-7.2 16,-16l0,-128c0,-8.8 -7.2,-16 -16,-16Zm144,16l0,128c0,8.8 7.2,16 16,16c8.8,0 16,-7.2 16,-16l0,-128c0,-8.8 -7.2,-16 -16,-16c-8.8,0 -16,7.2 -16,16Zm-64,-16c-8.8,0 -16,7.2 -16,16l0,128c0,8.8 7.2,16 16,16c8.8,0 16,-7.2 16,-16l0,-128c0,-8.8 -7.2,-16 -16,-16Zm144,16l0,128c0,8.8 7.2,16 16,16c8.8,0 16,-7.2 16,-16l0,-128c0,-8.8 -7.2,-16 -16,-16c-8.8,0 -16,7.2 -16,16Zm128,72c0,-13.3 10.7,-24 24,-24l72.8,0c16.8,0 32.7,7.5 43.3,20.5l58.9,71.9c5.8,7.1 9,16.1 9,25.3l0,90.3c0,17.7 -14.3,32 -32,32l-1.6,0c1,5.2 1.6,10.5 1.6,16c0,44.2 -35.8,80 -80,80c-44.2,0 -80,-35.8 -80,-80c0,-5.5 0.6,-10.8 1.6,-16l-163.2,0c1,5.2 1.6,10.5 1.6,16c0,44.2 -35.8,80 -80,80c-26.2,0 -49.4,-12.6 -64,-32c-14.6,19.4 -37.8,32 -64,32c-44.2,0 -80,-35.8 -80,-80l0,-48c0,-17.7 14.3,-32 32,-32l400,0l0,-152Zm48,88l105,0l-50,-61.1c-1.5,-1.9 -3.8,-2.9 -6.2,-2.9l-48.8,0l0,64Zm80,144c0,-17.555 -14.445,-32 -32,-32c-17.555,0 -32,14.445 -32,32c0,17.555 14.445,32 32,32c17.555,0 32,-14.445 32,-32Zm-352,32c17.555,0 32,-14.445 32,-32c0,-17.555 -14.445,-32 -32,-32c-17.555,0 -32,14.445 -32,32c0,17.555 14.445,32 32,32Zm-96,-32c0,-17.555 -14.445,-32 -32,-32c-17.555,0 -32,14.445 -32,32c0,17.555 14.445,32 32,32c17.555,0 32,-14.445 32,-32Z",
    style: {
      fill: "#3c5bd2",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeliver);
export default __webpack_public_path__ + "static/media/ic_deliver.eb0781014c333ba3513832975d2651f9.svg";
export { ForwardRef as ReactComponent };